module.exports = __webpack_public_path__ + "static/img/bg_3.314595c9.png";